import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import moment from "moment/moment";
import LoaderCircle from "../../../loader/LoaderCircle";
import NewsIcon from "../../../icons/NewsIcon";
import NewsController from "../../../../stories/_news/News/NewsController";
import AppContext from "../../../../context/AppContext";

const LastNews = () => {
	const { setEvent, setBubbleText } = useContext(AppContext);
	const [ list, setList ] = useState([]);
	const [ loading, setLoading ] = useState(true);

	const refresh = () => {
		const controller = new NewsController();
		controller._callback = handleRefresh;
		controller.index();
	}
	const handleRefresh = (list, error, pagination, status) => {
		setLoading(false);

		switch (status) {
			case 200:
				setList(list);
				break;
			default:
				setEvent({
					type: "error",
					text: "Une erreur s'est produite lors du chargement des dernières news"
				});
				break;
		}
	}
	const buildNews = (news, index) => {
		if (news.link !== null) {
			return <Link key={index} to={ news.link }>
				<div key={index} className={"elmt"}>
					<p className={"text"}>{ news.title }</p>
					<p className={"since"}>Il y a { moment(news.created_at).fromNow(true) }</p>
				</div>
			</Link>;
		}
		else {
			return <div key={index} className={"elmt"}>
				<p className={"text"}>{ news.title }</p>
				<p className={"since"}>Il y a { moment(news.created_at).fromNow(true) }</p>
			</div>;
		}
	}

	useEffect(() => {
		refresh();
	}, []);

    return (
        <div className="block lastViewed">
			<div className={"containerTitle"}>
				<NewsIcon />
				<p>Dernières news</p>
			</div>
			<div className={"list"}>
				{
					loading
						? <LoaderCircle display="loader loadingDashboard" strokeWidth="8" stroke="#006D3E" />
						: (
							list.length > 0
								? list.map((news, index) => buildNews(news, index))
								: <div className={"elmt empty"}><p className={"text empty"}>Aucune nouvelles</p></div>
						)
				}
			</div>
		</div>
    )
}

export default LastNews;
